import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../components/CheckoutForm";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
  "pk_test_51N4BMaGgNDimUjxY3aZ4eFC8osFpmDa0h9SXRzfHSJLmrTzXZvG8HbmRVXgR8m97vMU80ObFAuOSFfZr2ZOWxVft00NNHuk0Ue"
);

export default function Payment() {
    const options = {
    // passing the client secret obtained from the server
    clientSecret: 'sk_test_51N4BMaGgNDimUjxYRFP0Twid035y7vZvtrZTuL6nTSvwoOcdBgwSHVM2nRPULeAlCoAXMxWGBsxWDmrA2NN8s6yT00MPkWmoIv',
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm />
    </Elements>
  );
}
